/// <amd-module name="Artifacts/Connect/redux/Contracts" />
import { ToolId } from "Artifacts/Connect/types/ITool";
import { Uri } from "VSS/Platform/Util/Url";

export interface IConnectToFeedContainerState {
  dismissedTools: ToolId[];
  packagingUrl: string;
  sessionTokenUri: Uri;
}

export interface IConnectToFeedContainerOwnState {
  connectToFeed: IConnectToFeedContainerState;
}

export type ConnectToFeedData = IConnectToFeedContainerState;
